import styled from '@emotion/styled'

import { CONFIG } from '@/styles/emotion.config'

export const DetailsArticleStyles = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;

  p {
    flex-wrap: wrap;
    justify-content: center;
  }
  span {
    justify-content: center;
  }

  ${CONFIG.media.lg} {
    span,
    p {
      font-size: 1rem;
    }
  }

  ${CONFIG.media.mobileMd} {
    display: grid;
    grid-template-columns: 55% 43%;
    gap: 0.5rem;
  }
`
